import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

interface Props {
    colorField: 'searchButtonColor' | 'themeColor';
}

export const CustomColor = ({ colorField }: Props) => {
    const { customization, setCustomization } = useSearchAiPluginStore();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setCustomization(colorField, e.target.value);
    return (
        <div className="mt-6">
            <div className="flex items-center gap-4">
                <p className="mb-2 text-gray-600">Custom color:</p>
                <div
                    className="w-10 h-10 rounded-full border scale-110 ring-1 ring-offset-2 ring-blue-500"
                    style={{ backgroundColor: customization[colorField] }}
                />
                <input type="text" value={customization[colorField]} onChange={handleChange} className="border rounded-lg px-2 py-3 w-24 " />
            </div>
        </div>
    );
};
